export default "__VITE_ASSET__CkYIYWe1__"